import { Set } from 'immutable'
export default function stubImmutableSet() {
  return Set([])
}
